import React, { useState, useEffect } from 'react'

import AccordionContext from './AccordionContext'
import AccordionSection, { SectionContainer } from './AccordionSection'
import styled from 'styled-components'
import { Variables } from '../styles/Variables'

const StyledAccordion = styled.div`
    overflow: hidden;

    ${SectionContainer} {
        &:last-child {
            border-bottom: 1px solid ${Variables.color.pazolaGold};
        }
    }
`

export default function AccordionWrap({ children, singleOpen, defaultActive, theme }) {
    const [state, setState] = useState({})

    useEffect(() => {
        children.forEach((child) => {
            const { title, defaultOpen } = child.props
            setState((currentState) => ({ ...currentState, [title]: defaultOpen ? true : false }))
        })
    }, [children])

    useEffect(() => {
        const activeIndex = parseInt(defaultActive, 10)
        const isValidIndex = activeIndex < children.length

        if (defaultActive && isValidIndex) {
            const activeSection = children[activeIndex]
            const { title } = activeSection.props
            setState((s) => ({ ...s, [title]: true }))
        }
    }, [children, defaultActive])

    const toggleSection = (title) => {
        const isOpen = state[title]
        if (singleOpen) {
            setState({ [title]: !isOpen })
        } else {
            setState({ ...state, [title]: !isOpen })
        }
    }
    return (
        <AccordionContext.Provider value={{ ...state, toggleSection }}>
            <StyledAccordion>
                {children.map((child) => {
                    const { title, children: content, defaultOpen } = child.props
                    return (
                        <AccordionSection key={title} title={title} theme={theme} defaultOpen={defaultOpen}>
                            {content}
                        </AccordionSection>
                    )
                })}
            </StyledAccordion>
        </AccordionContext.Provider>
    )
}
